export const LOGOUT_ACTION_TYPE = 'LOGOUT_ACTION_TYPE';
